<template>
    <div>
        <div v-bind:class="[chatItem.is_recve== 1 ? 'doctor_box' : 'user_box']">
            <div class="title_box">{{ chatItem.user_name }}</div>

            <!-- 对话【文字:sayText】 -->
            <div class="msg_box" v-if="chatItem.type === 'sayText'">
                {{ chatItem.message.value }}
            </div>

            <!-- 对话【图片:sayImg】 -->
            <div class="msg_box" v-else-if="chatItem.type == 'sayImg'">
                <el-image :src="chatItem.message.value" :preview-src-list="chatItem.message.valueArray"
                          style="max-width:100%;heigth:auto">
                </el-image>
            </div>

            <!-- sayVoice：语音  -->
            <div class="msg_box" v-else-if="chatItem.type == 'sayVoice'">
                <audio :src="chatItem.message.value" muted controls preload="auto" ref="voice"></audio>
            </div>

            <!-- 对话【健康档案:sayHealthRecords】 -->
            <div v-else-if="chatItem.type == 'sayHealthRecords'">
                <p class="interaction_p" v-if="chatItem.type=='sayHealthRecords'">
                    <span>
                        <div style="margin: 0 auto;width:290px;background-color: rgba(228, 228, 228, 1);text-align: left;padding:13px;">
                            <div class="m-5">健康档案</div>
                            <div class="m-5">标题：{{chatItem['message']['value']['title']}}</div>
                            <div class="m-5">描述症状或特属专家建议(选填):{{chatItem['message']['value']['describe']}}</div>
                        </div>
                    </span>
                </p>
            </div>

            <!-- 对话【邀请:sayOther】 -->
            <div v-else-if="chatItem.type == 'sayOther'">
                <p class="interaction_p" v-if="chatItem.type=='sayOther'">
                    <span>
                        <div style="margin: 0 auto;width:290px;background-color: rgba(228, 228, 228, 1);text-align: left;padding:13px;">
                            <div class="m-5">邀请您会面</div>
                            <div class="m-5">时间：{{chatItem['message']['value']['value']['book_date']}} {{chatItem['message']['value']['value']['half']}}</div>
                            <div class="m-5">地点：{{chatItem['message']['value']['value']['address']}}</div>
                        </div>
                    </span>
                </p>
            </div>

            <div class="date_box">{{ chatItem.create_date }}</div>
        </div>
    </div>
</template>
<style scoped>

    .doctor_box {
        float: left;
        max-width: 333px;
        margin-top: 1rem;
    }

    .doctor_box .title_box {
        text-align: left;
    }

    .user_box {
        float: right;
        max-width: 333px;
        margin-top: 1rem;
    }

    .user_box .title_box {
        text-align: right;
    }

    .title_box {
        font-size: 14px;
        margin-bottom: 0.5rem;
    }

    .msg_box {
        background-color: rgba(242, 242, 242, 1);
        text-align: left;
        padding: 1rem 0.5rem;
        font-size: 15px;
        color: #999999;
        margin-bottom: 0.5rem;
    }

    .created_box {
        text-align: center;
        font-size: 1px;
        color: #999999;
    }

    .doctor_box >.date_box {
        text-align: left;
        color: #999999;
        font-size: 12px;
    }
    .user_box >.date_box {
        text-align: right;
        color: #999999;
        font-size: 12px;
    }

    .interaction_p {
        font-size: 12px;
        color: #999999;
        text-align: center;
    }

    .m-5 {
        margin: 5px 0;
    }

    .img-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    .image {
        margin: 3px;
    }

    img {
        width: 100px;
        height: 100px;
    }
</style>
<script>
    export default {
        props: {
            chatItem: {type: Object},
            userId: {type: String}
        },
        mounted() {

        }
    };
</script>
